module.exports = __webpack_public_path__ + "a0c4b3d49b6915537569cfe0675d3470.svg";